var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.33325C20.44 2.33325 25.6666 7.55992 25.6666 13.9999C25.6666 20.4399 20.44 25.6666 14 25.6666C7.55998 25.6666 2.33331 20.4399 2.33331 13.9999C2.33331 7.55992 7.55998 2.33325 14 2.33325ZM7.02719 17.9856C8.73928 20.5413 11.3109 22.1666 14.1863 22.1666C17.0617 22.1666 19.6333 20.5413 21.3454 17.9856C19.4699 16.2367 16.953 15.1666 14.1863 15.1666C11.4196 15.1666 8.90276 16.2367 7.02719 17.9856ZM14 12.8333C15.933 12.8333 17.5 11.2662 17.5 9.33325C17.5 7.40026 15.933 5.83325 14 5.83325C12.0669 5.83325 10.5 7.40026 10.5 9.33325C10.5 11.2662 12.0669 12.8333 14 12.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDp);
export default __webpack_public_path__ + "static/media/dp.d3158095168ace15776bc92835c48a45.svg";
export { ForwardRef as ReactComponent };